import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { WsModule } from "../../../core/dao/ws/ws.module";
import { ServiceModule } from "../../../core/services/service.module";
import { GyzmoButtonModule } from "../../../gyzmo-commons/components/gyzmo-button/gyzmo-button.module";
import { IriumInputModule } from "../../../gyzmo-commons/components/irium-input/irium-input.module";
import { PipesModule } from "../../../gyzmo-commons/helpers/pipes/pipes.module";
import { ConnectionPage } from "./connection.page";

@NgModule(
    {
        declarations: [
            ConnectionPage,
        ],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            PipesModule,
            TranslateModule,
            RouterModule.forChild([
                {
                    path: "",
                    component: ConnectionPage,
                },
            ]),
            WsModule,
            ServiceModule,
            GyzmoButtonModule,
            IriumInputModule,
            ReactiveFormsModule,
        ],
        exports: [
            ConnectionPage,
        ],
        providers: [],
    })

export class ConnectionPageModule {
}
